import styled from 'styled-components';
import {NavLink} from 'react-router-dom';

export const LinkContainer = styled.div`
  display: inline-block;

  &:first-of-type {
    margin-left: 30px;
  }
`;

interface NavLinkProps {
  activeStyle: {
    color: string;
    fontWeight: string;
    borderBottom: string;
  }
}

export const ActiveLink = styled(NavLink)<NavLinkProps>`
  margin: 0 18px;
  font-size: 16px;
  transition: 0.3s ease;
  display: inline-block;
  text-decoration: none;
  padding: 18px 0 20px 0;
  border-bottom: '#fff 3px solid';
  color: var(--MediumGray);

  &:hover {
    color: var(--DarkGray);
  }

  &.active{
    color: ${props => props.activeStyle.color};
    font-weight: ${props => props.activeStyle.fontWeight};
    border-bottom: ${props => props.activeStyle.borderBottom};
  }
`;
